import listActions from 'src/modules/project/list/projectListActions';
import ProjectService from 'src/modules/project/projectService';
import Errors from 'src/modules/shared/error/errors';
import {i18n} from 'src/i18n';
import {getHistory} from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'PROJECT_DESTROY';

const projectDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: projectDestroyActions.DESTROY_STARTED,
      });

      await ProjectService.destroyAll([id]);

      dispatch({
        type: projectDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.project.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/project');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: projectDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: projectDestroyActions.DESTROY_ALL_STARTED,
      });

      await ProjectService.destroyAll(ids);

      dispatch({
        type: projectDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.project.destroyAll.success'));

      getHistory().push('/project');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: projectDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default projectDestroyActions;
